module.exports = __webpack_public_path__ + "img/icon34.b2bbea0a.png";